<template>
    <div v-if="features.length" class="d-flex">
        <!--eslint-disable-next-line vue/singleline-html-element-content-newline-->
        <p class="mb-0 text-no-wrap text-success font-weight-medium text-caption">
            {{ $t('carsRent.price_includes') }}:
        </p>
        <div class="d-flex flex-wrap align-center">
            <small v-for="name in features" :key="name" class="ml-3">
                <v-icon :title="$t(`carsRent.${name.toLowerCase()}`)" color="success" start size="small" class="mr-1">
                    mdi-checkbox-marked-circle
                </v-icon>
                <span v-text="$t(`carsRent.${name.toLowerCase()}`)" />
            </small>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class FeatureIncludes extends Vue {
        @Prop({default: () => [], type: Array, required: true}) features
    }

    export default FeatureIncludes
</script>
